import styled from 'styled-components'
import { POST } from 'locales/locales'
import CustomText from 'components/text/CustomText'
import CustomModal from 'components/modals/CustomModal'
import { IconSourceType } from 'components/icon/CustomIcon'
import Avatar, { AvatarSize } from 'components/avatar/Avatar'
import { IUser, IUserData } from 'types/user.types'

interface IPostReactionsProps {
  reactions: {
    emoji: string
    users: string[]
  }[]
  userData: IUserData;
  onClose: () => void
}

//Array<{ _id: string; avatar: string; fullname: string }>
const MessageReactions = ({ reactions, userData, onClose }: IPostReactionsProps) => {


  const updatedReactions = reactions.map(reaction => {
    const updatedUsers = reaction.users.map(userId => userData[userId] || { _id: userId });
    return { ...reaction, users: updatedUsers };
  });

  const tab: Array<{ title: string; action?: boolean; icon?: IconSourceType }> = []

  for (const reaction of updatedReactions) {
    tab.push({ title: reaction.users.length.toString() + reaction.emoji || '',  })
  }

  return (
    <CustomModal
      showButtons={false}
      size="large"
      closeModal={onClose}
      title={POST.REACTIONS}
      tab={tab}
    >
      {updatedReactions.map((reaction: { users: IUser[]; emoji: string }) => (
        <ReactionList key={reaction.emoji}>
          {reaction?.users.map((user: IUser) => (
            <ReactionPeopleWrapper key={user._id}>
              <Avatar source={user?.avatar} text={user.fullname} size={AvatarSize.average} />
              <CustomText typography="header3">{user.fullname}</CustomText>
            </ReactionPeopleWrapper>
          ))}
        </ReactionList>
      ))}
    </CustomModal>
  )
}

export default MessageReactions

const ReactionList = styled.div`
  padding-top: 10px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  row-gap: 10px;
`

const ReactionPeopleWrapper = styled.div`
  display: flex;
  column-gap: 10px;
  align-items: center;
`